import { create } from 'zustand';

interface StartupWorkflowState {
  startupWorkflowUrl: string;
  setStartupWorkflowUrl: (url: string) => void;
  clearStartupWorkflowUrl: () => void;
}

export const useStartupWorkflowStore = create<StartupWorkflowState>((set) => ({
  startupWorkflowUrl: '',
  setStartupWorkflowUrl: (url) => set({ startupWorkflowUrl: url }),
  clearStartupWorkflowUrl: () => set({ startupWorkflowUrl: '' }),
}));